import { fillColors } from './fill-colors';
import { iconColors } from './icon-colors';
import { labelColors } from './label-colors';

export { fillColors, iconColors, labelColors };

export const LAYERS = {
  fillColors,
  iconColors,
  labelColors,
};
